export {
  fetchFilters,
  fetchJobs,
  postApply,
  type Job,
  type JobFilter,
  type JobFilters,
  type JobsObject,
} from "./api"
export { cutString } from "./cutString"
export { extractMenuProperties } from "./extractMenuProperties"
export { extractProperty } from "./extractProperty"
export { findProperty } from "./findProperty"
export { schemaCommon, userSchema } from "./Form/FormSchema"
export {
  getAlternateMetadataFromHeader,
  getAlternateMetadataFromPathname,
} from "./getAlternateMetadataFromHeader"
export { getBreadCrumbs } from "./getBreadCrumbs"
export type { Item } from "./getItemsList"
export { getNonUmbracoUrl } from "./getNonUmbracoUrl"
export { getUmbracoMediaUrl } from "./getUmbracoMediaUrl"
export { getUmbracoPDFUrl } from "./getUmbracoPDFUrl"
export { getUmbracoUrl } from "./getUmbracoUrl"
export { extractMetaTags } from "./metaTags"
export { ReactQueryContext } from "./ReactQueryContext"
export { useOutsideClick } from "./UseOutsideClick"

export * from "./types"
export { useApi } from "./useApi"

export { getFavicons } from "./getFavicons"

export { getLastPath } from "./getLastUrlPath"

export { createSearchParams } from "./createSearchParams"

export { restoreSearchparams } from "./createSearchParams"

export { ensureHttps } from "./utils"

export { getPreviewTextFromRichText, stripHtmlToText } from "./htmlTextUtils"

export { useUtmUrl } from "./useUtmUrl"
